angular.module('unergie.main')
.directive('forceUppercase', () => ({
    restrict: 'A',
    require: 'ngModel',
    link(scope, element, attrs, modelCtrl) {
        const uppercase = (input) => (attrs.forceUppercaseDisabled === 'true' || _.isEmpty(input) ? input : input.toUpperCase())

        scope.$watch(
            () => attrs.forceUppercaseDisabled,
            () => element[(attrs.forceUppercaseDisabled === 'true' ? 'removeClass' : 'addClass')]('force-uppercase')
        )

        modelCtrl.$parsers.push(uppercase)
        uppercase(scope[attrs.ngModel])
    },
}))
